import { css } from 'styled-components';
import colors from 'styles/theme/colors';

const hopscotch = css`
/**! hopscotch - v0.3.1
*
* Copyright 2017 LinkedIn Corp. All rights reserved.
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*     http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/
/**
 * This fade animation is based on Dan Eden's animate.css (http://daneden.me/animate/), under the terms of the MIT license.
 *
 * Copyright 2013 Dan Eden.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */
.animated {
  -webkit-animation-fill-mode: both;
  -moz-animation-fill-mode: both;
  -ms-animation-fill-mode: both;
  -o-animation-fill-mode: both;
  animation-fill-mode: both;
  -webkit-animation-duration: 1s;
  -moz-animation-duration: 1s;
  -ms-animation-duration: 1s;
  -o-animation-duration: 1s;
  animation-duration: 1s;
}
@-webkit-keyframes fadeInUp {
  0% {
    opacity: 0;
    -webkit-transform: translateY(20px);
  }
  100% {
    opacity: 1;
    -webkit-transform: translateY(0);
  }
}
@-moz-keyframes fadeInUp {
  0% {
    opacity: 0;
    -moz-transform: translateY(20px);
  }
  100% {
    opacity: 1;
    -moz-transform: translateY(0);
  }
}
@-o-keyframes fadeInUp {
  0% {
    opacity: 0;
    -o-transform: translateY(20px);
  }
  100% {
    opacity: 1;
    -o-transform: translateY(0);
  }
}
@keyframes fadeInUp {
  0% {
    opacity: 0;
    transform: translateY(20px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}
.fade-in-up {
  -webkit-animation-name: fadeInUp;
  -moz-animation-name: fadeInUp;
  -o-animation-name: fadeInUp;
  animation-name: fadeInUp;
}
@-webkit-keyframes fadeInDown {
  0% {
    opacity: 0;
    -webkit-transform: translateY(-20px);
  }
  100% {
    opacity: 1;
    -webkit-transform: translateY(0);
  }
}
@-moz-keyframes fadeInDown {
  0% {
    opacity: 0;
    -moz-transform: translateY(-20px);
  }
  100% {
    opacity: 1;
    -moz-transform: translateY(0);
  }
}
@-o-keyframes fadeInDown {
  0% {
    opacity: 0;
    -ms-transform: translateY(-20px);
  }
  100% {
    opacity: 1;
    -ms-transform: translateY(0);
  }
}
@keyframes fadeInDown {
  0% {
    opacity: 0;
    transform: translateY(-20px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}
.fade-in-down {
  -webkit-animation-name: fadeInDown;
  -moz-animation-name: fadeInDown;
  -o-animation-name: fadeInDown;
  animation-name: fadeInDown;
}
@-webkit-keyframes fadeInRight {
  0% {
    opacity: 0;
    -webkit-transform: translateX(-20px);
  }
  100% {
    opacity: 1;
    -webkit-transform: translateX(0);
  }
}
@-moz-keyframes fadeInRight {
  0% {
    opacity: 0;
    -moz-transform: translateX(-20px);
  }
  100% {
    opacity: 1;
    -moz-transform: translateX(0);
  }
}
@-o-keyframes fadeInRight {
  0% {
    opacity: 0;
    -o-transform: translateX(-20px);
  }
  100% {
    opacity: 1;
    -o-transform: translateX(0);
  }
}
@keyframes fadeInRight {
  0% {
    opacity: 0;
    transform: translateX(-20px);
  }
  100% {
    opacity: 1;
    transform: translateX(0);
  }
}
.fade-in-right {
  -webkit-animation-name: fadeInRight;
  -moz-animation-name: fadeInRight;
  -o-animation-name: fadeInRight;
  animation-name: fadeInRight;
}
@-webkit-keyframes fadeInLeft {
  0% {
    opacity: 0;
    -webkit-transform: translateX(20px);
  }
  100% {
    opacity: 1;
    -webkit-transform: translateX(0);
  }
}
@-moz-keyframes fadeInLeft {
  0% {
    opacity: 0;
    -moz-transform: translateX(20px);
  }
  100% {
    opacity: 1;
    -moz-transform: translateX(0);
  }
}
@-o-keyframes fadeInLeft {
  0% {
    opacity: 0;
    -o-transform: translateX(20px);
  }
  100% {
    opacity: 1;
    -o-transform: translateX(0);
  }
}
@keyframes fadeInLeft {
  0% {
    opacity: 0;
    transform: translateX(20px);
  }
  100% {
    opacity: 1;
    transform: translateX(0);
  }
}
.fade-in-left {
  -webkit-animation-name: fadeInLeft;
  -moz-animation-name: fadeInLeft;
  -o-animation-name: fadeInLeft;
  animation-name: fadeInLeft;
}
div.hopscotch-bubble .hopscotch-nav-button {
  /* borrowed from katy styles */
  font-weight: bold;
  border-width: 1px;
  border-style: solid;
  cursor: pointer;
  margin: 0;
  overflow: visible;
  text-decoration: none !important;
  width: auto;
  padding: 0 10px;
  height: 26px;
  line-height: 24px;
  font-size: 12px;
  *zoom: 1;
  white-space: nowrap;
  display: -moz-inline-stack;
  display: inline-block;
  *vertical-align: auto;
  zoom: 1;
  *display: inline;
  vertical-align: middle;
  -moz-border-radius: 0px;
  -ms-border-radius: 0px;
  -o-border-radius: 0px;
  -webkit-border-radius: 0px;
  border-radius: 0px;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
}
div.hopscotch-bubble .hopscotch-nav-button.next {
  border: none;
  color: #fff;
  margin: 0 0 0 10px;
  /* HS specific*/
  text-shadow: 0 1px 1px rgba(0, 0, 0, 0.35);
  background-color: ${colors.base.Teal};
}
div.hopscotch-bubble .hopscotch-nav-button.next:hover {
  background-color: ${colors.base.TealSupport};
}
div.hopscotch-bubble .hopscotch-nav-button.prev {
  border: none;
  color: #444;
  text-shadow: 0 1px 1px rgba(255, 255, 255, 0.75);
  background-color: #f2f2f2;
}
div.hopscotch-bubble .hopscotch-nav-button.prev:hover {
  background-color: #e8e8e8;
}
div.hopscotch-bubble {
  background-color: #ffffff;
  border: 3px solid ${colors.base.Black};
  color: ${colors.base.Black};
  font-family: 'IBM Plex Sans', Helvetica, Arial, sans-serif;
  font-size: 13px;
  position: absolute;
  z-index: 999999;
  -webkit-box-sizing: content-box;
  -moz-box-sizing: content-box;
  box-sizing: content-box;
  -moz-background-clip: padding;
  /* for Mozilla browsers*/
  -webkit-background-clip: padding;
  /* Webkit */
  background-clip: padding-box;
  /*  browsers with full support */
}
div.hopscotch-bubble * {
  -webkit-box-sizing: content-box;
  -moz-box-sizing: content-box;
  box-sizing: content-box;
}
div.hopscotch-bubble.animate {
  -moz-transition-property: top, left;
  -moz-transition-duration: 1s;
  -moz-transition-timing-function: ease-in-out;
  -ms-transition-property: top, left;
  -ms-transition-duration: 1s;
  -ms-transition-timing-function: ease-in-out;
  -o-transition-property: top, left;
  -o-transition-duration: 1s;
  -o-transition-timing-function: ease-in-out;
  -webkit-transition-property: top, left;
  -webkit-transition-duration: 1s;
  -webkit-transition-timing-function: ease-in-out;
  transition-property: top, left;
  transition-duration: 1s;
  transition-timing-function: ease-in-out;
}
div.hopscotch-bubble.invisible {
  opacity: 0;
}
div.hopscotch-bubble.hide,
div.hopscotch-bubble .hide,
div.hopscotch-bubble .hide-all {
  display: none;
}
div.hopscotch-bubble h3 {
  color: ${colors.base.Teal};
  font-family: 'IBM Plex Sans', Helvetica, Arial, sans-serif;
  font-size: 16px;
  font-weight: bold;
  line-height: 19px;
  margin: -1px 15px 0 0;
  padding: 0;
}
div.hopscotch-bubble .hopscotch-bubble-container {
  padding: 15px;
  position: relative;
  text-align: left;
  -webkit-font-smoothing: antialiased;
  /* to fix text flickering */
}
div.hopscotch-bubble .hopscotch-content {
  font-family: 'IBM Plex Sans', Helvetica, Arial, sans-serif;
  font-weight: normal;
  line-height: 17px;
  margin: -5px 0 11px;
  padding-top: 8px;
  color: ${colors.base.Gray};
}
div.hopscotch-bubble .hopscotch-bubble-content {
  margin: 0;
}
div.hopscotch-bubble.no-number .hopscotch-bubble-content {
  margin: 0;
}
div.hopscotch-bubble .hopscotch-bubble-close {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  border: 0;
  color: #000;
  background: transparent url(data:image/png;base64,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) -192px -92px no-repeat;
  display: block;
  padding: 8px;
  position: absolute;
  text-decoration: none;
  text-indent: -9999px;
  width: 8px;
  height: 8px;
  top: 0;
  right: 0;
}
div.hopscotch-bubble .hopscotch-bubble-close.hide,
div.hopscotch-bubble .hopscotch-bubble-close.hide-all {
  display: none;
}
div.hopscotch-bubble .hopscotch-bubble-number {
  color: ${colors.base.Teal};
  display: none;
  float: left;
  font-size: 17px;
  font-weight: bold;
  line-height: 31px;
  padding: 0 10px 0 0;
  text-align: center;
  width: 30px;
  height: 30px;
}
div.hopscotch-bubble .hopscotch-bubble-arrow-container {
  position: absolute;
  width: 34px;
  height: 34px;
}
div.hopscotch-bubble .hopscotch-bubble-arrow-container .hopscotch-bubble-arrow,
div.hopscotch-bubble .hopscotch-bubble-arrow-container .hopscotch-bubble-arrow-border {
  width: 0;
  height: 0;
}
div.hopscotch-bubble .hopscotch-bubble-arrow-container.up {
  top: -18px;
  left: 10px;
}
div.hopscotch-bubble .hopscotch-bubble-arrow-container.up .hopscotch-bubble-arrow {
  border-bottom: 17px solid #ffffff;
  border-left: 17px solid transparent;
  border-right: 17px solid transparent;
  position: relative;
  top: -12px;
}
div.hopscotch-bubble .hopscotch-bubble-arrow-container.up .hopscotch-bubble-arrow-border {
  border-bottom: 17px solid ${colors.base.Black};
  border-left: 17px solid transparent;
  border-right: 17px solid transparent;
}
div.hopscotch-bubble .hopscotch-bubble-arrow-container.down {
  bottom: -36px;
  left: 10px;
}
div.hopscotch-bubble .hopscotch-bubble-arrow-container.down .hopscotch-bubble-arrow {
  border-top: 17px solid #ffffff;
  border-left: 17px solid transparent;
  border-right: 17px solid transparent;
  position: relative;
  top: -21px;
}
div.hopscotch-bubble .hopscotch-bubble-arrow-container.down .hopscotch-bubble-arrow-border {
  border-top: 17px solid ${colors.base.Black};
  border-left: 17px solid transparent;
  border-right: 17px solid transparent;
}
div.hopscotch-bubble .hopscotch-bubble-arrow-container.left {
  top: 10px;
  left: -20px;
}
div.hopscotch-bubble .hopscotch-bubble-arrow-container.left .hopscotch-bubble-arrow {
  border-bottom: 17px solid transparent;
  border-right: 17px solid #ffffff;
  border-top: 17px solid transparent;
  position: relative;
  left: 4px;
  top: -34px;
}
div.hopscotch-bubble .hopscotch-bubble-arrow-container.left .hopscotch-bubble-arrow-border {
  border-right: 17px solid ${colors.base.Black};
  border-bottom: 17px solid transparent;
  border-top: 17px solid transparent;
}
div.hopscotch-bubble .hopscotch-bubble-arrow-container.right {
  top: 10px;
  right: -36px;
}
div.hopscotch-bubble .hopscotch-bubble-arrow-container.right .hopscotch-bubble-arrow {
  border-bottom: 17px solid transparent;
  border-left: 17px solid #ffffff;
  border-top: 17px solid transparent;
  position: relative;
  left: -5px;
  top: -34px;
}
div.hopscotch-bubble .hopscotch-bubble-arrow-container.right .hopscotch-bubble-arrow-border {
  border-left: 17px solid ${colors.base.Black};
  border-bottom: 17px solid transparent;
  border-top: 17px solid transparent;
}
div.hopscotch-bubble .hopscotch-actions {
  margin: 10px 0 0;
  text-align: right;
}
`;

export default hopscotch;



// WEBPACK FOOTER //
// ./src/styles/global/hopscotch.js